export type PaginationParams = {
  page?: number | null;
  perPage?: number;
  sortBy?: string;
};

export const appendPagination = (
  query: URLSearchParams,
  { page, perPage, sortBy }: PaginationParams = {},
) => {
  query.append('pg', String(page ?? 1));
  query.append('ps', String(perPage ?? 10));
  query.append('sort', sortBy ?? '');
};
